import * as React from 'react';
import { Icon } from 'antd';
import { getBidTotal } from '../pages/Enquiry/InquiryUtils';

export default function PriceTotal(props) {
  const amountTotal = getBidTotal(props.amount);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        ...(props.commentTextStyle ? { justifyContent: 'flex-end' } : undefined),
      }}
    >
      <span
        style={{
          marginRight: 10,
          color: '#333333',
          ...(props.commentTextStyle ? { fontSize: 14 } : { fontSize: 10 }),
        }}
      >
        Total Price
      </span>
      <div
        style={{
          fontSize: 12,
          fontWeight: 600,
          color: '#111111',
          lineHeight: '75%',
        }}
      >
        {props?.source !== 'INQUIRY' ? (
          <span
            style={{
              fontSize: 10,
              verticalAlign: 'top',
              lineHeight: '6px',
            }}
          >
            &nbsp;{props.currencySymbol}
          </span>
        ) : (
          ''
        )}
        <span style={{ fontSize: 14 }}>{amountTotal}</span>
        {props?.source === 'INQUIRY' ? (
          <span
            style={{
              lineHeight: '6px',
            }}
          >
            &nbsp;{props.currencySymbol}
          </span>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}
